import { isReactNative } from 'yofobasement/utils/runtime';

let DeviceEventEmitter = {
  addListener: (eventName, listener) => {},
  emit: (eventName, data) => {}
};

if (isReactNative()) {
  DeviceEventEmitter = require('react-native').DeviceEventEmitter;
}

export default DeviceEventEmitter;



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/DeviceEventEmitter.js